import { createFileRoute } from '@tanstack/react-router'
import { LegalChoicesPage } from '@/features/legal/legal-choices-page'

export const Route = createFileRoute('/settings/legal')({
  component: LegalChoicesPage,
})
